import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlRemoveQuantity =`${webUrlBase}api/mobile/table_orders/remove_item`;
export const urlDeleteOrderItem =`${webUrlBase}api/mobile/table_orders/delete_item`;
export const urlConfirmUserOrder =`${webUrlBase}api/mobile/table_orders/confirm_user_order`;
export const urlDeleteAllItems =`${webUrlBase}api/mobile/table_orders/delete_all_items`;